/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getF64Decoder,
  getF64Encoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Longitude range for geographic constraints */
export type LongitudeRange = {
  /** Minimum longitude */
  min: number;
  /** Maximum longitude */
  max: number;
};

export type LongitudeRangeArgs = LongitudeRange;

export function getLongitudeRangeEncoder(): FixedSizeEncoder<LongitudeRangeArgs> {
  return getStructEncoder([
    ["min", getF64Encoder()],
    ["max", getF64Encoder()],
  ]);
}

export function getLongitudeRangeDecoder(): FixedSizeDecoder<LongitudeRange> {
  return getStructDecoder([
    ["min", getF64Decoder()],
    ["max", getF64Decoder()],
  ]);
}

export function getLongitudeRangeCodec(): FixedSizeCodec<
  LongitudeRangeArgs,
  LongitudeRange
> {
  return combineCodec(getLongitudeRangeEncoder(), getLongitudeRangeDecoder());
}
